<script>import * as d3 from "d3";
import { v4 as uuidv4 } from "uuid";
import { tweened } from "svelte/motion";
import { cubicOut } from "svelte/easing";
export let duration = 400;
export let easing = cubicOut;
export let barDatum;
export let title = void 0;
export let orientation;
export let textPosition = "inside";
export let fontSize = 10;
export let titleMargin = 9;
export let fgColor = void 0;
const barSize = orientation === "vertical" ? barDatum.width : barDatum.height;
const hTextDy = fontSize * 0.32;
const vTextDy = fontSize * 0.68;
const textX = textPosition === "inside" ? orientation === "vertical" ? (rect) => rect.x + barSize / 2 - hTextDy : (rect) => rect.x + titleMargin : orientation === "vertical" ? (rect) => rect.x + barSize + titleMargin : (rect) => rect.x + rect.width / 2;
const textY = textPosition === "inside" ? orientation === "vertical" ? (rect) => rect.y + rect.height - titleMargin + vTextDy : (rect) => rect.y + barSize / 2 + hTextDy : orientation === "vertical" ? (rect) => rect.y + rect.height / 2 : (rect) => rect.y - titleMargin;
const transform = textPosition === "inside" ? orientation === "vertical" ? (rect) => `rotate(-90, ${textX(rect)}, ${textY(rect) - vTextDy})` : (rect) => "" : orientation === "vertical" ? (rect) => "" : (rect) => `rotate(-90, ${textX(rect)}, ${textY(rect)})`;
const tweenBarDatum = tweened(barDatum, {
  duration,
  easing,
  interpolate: (from, to) => {
    const interpolate = d3.interpolate(from, to);
    return (t) => interpolate(t);
  }
});
$: {
  tweenBarDatum.set(barDatum);
}
const id = uuidv4();
</script>

<g class="bar">
  {#if title}
  {#if textPosition === 'inside'}
    <clipPath id={`clip-${id}`}>
      {#if orientation === "horizontal"}
        <rect
          x={$tweenBarDatum.x}
          width={$tweenBarDatum.width}
          y={$tweenBarDatum.y}
          height={$tweenBarDatum.height}
        />
      {:else}
        <rect
          x={$tweenBarDatum.x}
          width={$tweenBarDatum.height}
          y={$tweenBarDatum.y + $tweenBarDatum.height - $tweenBarDatum.width}
          height={$tweenBarDatum.width}
        />
      {/if}
    </clipPath>
    {/if}
    <text
      x={textX($tweenBarDatum)}
      y={textY($tweenBarDatum)}
      dy={0}
      transform={transform($tweenBarDatum)}
      >{title(barDatum.data)}</text
    >
  {/if}
  <rect
    x={$tweenBarDatum.x}
    width={$tweenBarDatum.width}
    height={$tweenBarDatum.height}
    y={$tweenBarDatum.y}
    fill={barDatum.data.color.formatHex()}
    fill-opacity={barDatum.data.color.opacity}
  />
  {#if title && textPosition === 'inside'}
    <text
      x={textX($tweenBarDatum)}
      y={textY($tweenBarDatum)}
      dy={0}
      transform={transform($tweenBarDatum)}
      style={`fill:${fgColor ? fgColor(barDatum.data.color) : "transparent"}`}
      opacity="1"
      clip-path={`url(#clip-${id})`}>{title(barDatum.data)}</text
    >
  {/if}
</g>
